export const BASE_URL = process.env.REACT_APP_STRAPI_URL;
export const AUTH_PATH = process.env.REACT_APP_AUTH_PATH;
export const ESTABLISHMENTS_PATH = process.env.REACT_APP_ESTABLISHMENTS_PATH;
export const MESSAGES_PATH = process.env.REACT_APP_MESSAGES_PATH;
export const ENQUIRIES_PATH = process.env.REACT_APP_ENQUIRIES_PATH;
